// extracted by mini-css-extract-plugin
module.exports = {"flickrGallery":"_6yStER","sectionMainHeading":"_1aCiVS","wrapperLink":"_3-DdGR"};